export default __webpack_public_path__ + "static/media/failedUpload.7fec1b62.svg";